import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bettendorfConfig } from "./data";

export default function BettendorfPage() {
  return <CityPageTemplate config={bettendorfConfig} />;
}